export const AI_DYNAMIC_TOKEN_SETTINGS = 'hsAiDynamicTokens';
export const hsAIDynamicTokensConfig = {
  USE_AI_DYNAMIC_TOKENS: 'useAIDynamicTokens',
  CAN_INSERT_DYNAMIC_TOKENS: 'canInsertDynamicTokens'
};